import Cognito from "..//Amplify";

import { api } from "../middlewares";

const changeEmailRequests = {
  idTokenSensedia: "",

  changeEmail: async (email) => {
    try {
      let resultInitial = await api.patch(
        "/Perfil/InitialEditEmail",
        {},
        {
          params: { temp_email: email },
        }
      );

      return resultInitial.data;
    } catch (error) {
      if (error.response.data.temp_email) {
        Cognito.resendCode(error.response.data.temp_email);

        return error.response.data.temp_email;
      }
    }
  },

  deleteEmailBancoECognito: async () => {
    try {
      await api.delete("/DeleteContaAntiga");
    } catch (error) {
      return error;
    }
  },

  changeEmailSalesForce: async (email) => {
    try {
      await api.patch("/Perfil/EditEmailBDSales", {
        email: email,
      });

      return true;
    } catch (error) {
      return false;
    }
  },
};

export default changeEmailRequests;
